import React from 'react';

import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import Table from 'components/data-visualization/Table/Table';
import { Head, Label } from 'components/data-visualization/Table/SortingHead';
import Row from 'components/data-visualization/Table/Row';
import TableBody from 'components/data-visualization/Table/Body';

import useMedia from 'hooks/useMedia';

import {
  Header,
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';

interface ISkeletonLoader {
  title: string;
  short: boolean;
}
const SkeletonLoader: React.FC<ISkeletonLoader> = (props) => {
  const { title, short } = props;
  const isLargeScreen = useMedia('(min-width: 60em)');
  const columnCount = 6;

  return (
    <GenericComponent
      title={title}
      loading={true}
      success={false}
      showToolbarDropdown={false}
      isNarrowScreen
      short={short}
    >
      <AnimatedLoadingWrapper loading={true}>
        <Table cellSpacing="0" cellPadding="0">
          {isLargeScreen && (
            <Head>
              <Row>
                <Header textAlign="center">
                  <Label>Country</Label>
                </Header>
                <Header>
                  <Label>Official Local</Label>
                </Header>
                <Header>
                  <Label>Radio</Label>
                </Header>
                <Header>
                  <Label>Spotify</Label>
                </Header>
                <Header>
                  <Label>Shazam</Label>
                </Header>
                {/* <Header>
                  <Label>iTunes</Label>
                </Header> */}
              </Row>
            </Head>
          )}
          <TableBody>
            <TableLoader
              columnCount={columnCount}
              rowComponent={TableRow}
              cellComponent={TableCell}
            />
          </TableBody>
        </Table>
      </AnimatedLoadingWrapper>
    </GenericComponent>
  );
};

export default SkeletonLoader;
